var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.amount),function(i){return _c('div',{key:i,staticClass:"custom-spacer"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }